import React, { Component } from 'react'
import { connect } from 'redaction'
import { constants } from 'common/helpers'
import { some } from 'lodash'
import cx from 'classnames'

import Link from 'components/ui/Link/Link'

import HeaderSubNavItemTitle from '../HeaderSubNavItemTitle/HeaderSubNavItemTitle'

import s from './Mobile.scss'


class HeaderSubNavExceptMobile extends Component {

  static defaultProps = {
    nav: [],
  }

  state = {
    activeNavItemIndex: -1,
  }

  node = React.createRef()
  subMenuRef = React.createRef()

  componentDidMount() {
    this.bindListeners()
  }

  componentWillUnmount() {
    this.unbindListeners()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      activeNavItemIndex: prevActiveNavItemIndex,
    } = prevState

    const { activeNavItemIndex } = this.state

    if (
      prevActiveNavItemIndex !== activeNavItemIndex
      && activeNavItemIndex !== -1
      && this.subMenuRef.current
    ) {
      // focus on the first subitem on open
      this.subMenuRef.current.querySelector('[role="menuitem"]').focus()
    }
  }

  bindListeners() {
    document.addEventListener('click', this.handleBodyClick)
  }

  unbindListeners() {
    document.removeEventListener('click', this.handleBodyClick)
  }

  handleBodyClick = (event) => {
    // TODO check this in IE
    if (!this.node.current || this.node.current.contains(event.target) || this.node.current.isEqualNode(event.target)) {
      return
    }

    this.hideSubMenu()
  }

  setNavItemActive = (activeNavItemIndex) => {
    this.setState({ activeNavItemIndex })
  }

  hideSubMenu = () => {
    this.setState({ activeNavItemIndex: -1 })
  }

  checkIfSectionIsActive = (subNav = []) => {
    const { pathname } = this.props

    return some(subNav, ({ to }) => to === pathname)
  }

  handleClick = ({ onClick, index }) => (event) => {
    this.setNavItemActive(index)

    if (typeof onClick === 'function') {
      onClick(event)
    }
  }

  render() {
    const { activeNavItemIndex } = this.state
    const { nav } = this.props

    const activeNavItem = nav[activeNavItemIndex]
    const isSubMenuVisible = Boolean(activeNavItemIndex >= 0 && activeNavItem.subNav)

    return (
      <div className={s.navContainer} ref={this.node}>
        <div className={s.nav}>
          <div className={s.navRow} data-testid={constants.testIds.layout.headerNav} role="menubar">
            {
              nav.map(({ subNav, title, to, toOLD, linkId, onClick, dataTestId }, index) => {
                const isActive = activeNavItemIndex === index
                const isSectionActive = this.checkIfSectionIsActive(subNav)
                const hasSubMenu = Boolean(subNav)

                const className = cx(s.navItem, {
                  withBorder: isActive && isSubMenuVisible,
                })

                const id = linkId || `header-nav-${dataTestId}`
                const linkIsActive = isActive || isSectionActive && !isSubMenuVisible
                const handleClick = isActive ? this.hideSubMenu : this.handleClick({ onClick, index })

                if (hasSubMenu) {
                  return (
                    <button
                      key={index}
                      type="button"
                      id={id}
                      className={className}
                      onClick={handleClick}
                      role="menuitem"
                      aria-haspopup="menu"
                      aria-expanded={isActive}
                      data-testid={dataTestId}
                    >
                      <HeaderSubNavItemTitle
                        title={title}
                        isActive={linkIsActive}
                      />
                    </button>
                  )
                }

                return (
                  <HeaderSubNavItemTitle
                    key={index}
                    className={className}
                    title={title}
                    to={to}
                    toOLD={toOLD}
                    linkId={id}
                    onClick={handleClick}
                    isActive={linkIsActive}
                    dataTestId={dataTestId}
                    role="menuitem"
                  />
                )
              })
            }
          </div>
        </div>
        {
          isSubMenuVisible && (
            <div
              ref={this.subMenuRef}
              className={s.subMenu}
              role="menu"
              aria-labelledby={activeNavItem.linkId || `header-nav-${activeNavItem.dataTestId}`}
            >
              {
                activeNavItem.subNav.map(({ title, to, toOLD, linkId, dataTestId, onClick, bold, isLine }, index) => {
                  if (isLine) {
                    return <div key={index} className={s.line} />
                  }

                  const isInlineBlock = activeNavItem.isBig && !bold

                  return (
                    <Link
                      key={index}
                      className={cx(s.subItem, { [s.inlineBlock]: isInlineBlock })}
                      id={linkId}
                      title={title}
                      to={to}
                      toOLD={toOLD}
                      customColor
                      bold={bold}
                      dataTestId={dataTestId}
                      role="menuitem"
                      onClick={() => {
                        this.hideSubMenu()

                        if (typeof onClick === 'function') {
                          onClick()
                        }
                      }}
                    />
                  )
                })
              }
            </div>
          )
        }
      </div>
    )
  }
}


export default connect({
  pathname: 'routing.location.pathname',
})(HeaderSubNavExceptMobile)
